import { Injectable } from '@angular/core';
import { ITimeBlockComponentItem } from '../../types/time-block-component-item-types';

@Injectable()
export class TimeBlockIntersectionService {
  public intersects(first: ITimeBlockComponentItem, second: ITimeBlockComponentItem): boolean {
    const startFirst = first.timeBlockModel.start;
    const endFirst = first.timeBlockModel.end;
    const startSecond = second.timeBlockModel.start;
    const endSecond = second.timeBlockModel.end;

    return (
      (startFirst <= startSecond && endFirst > startSecond) ||
      (endFirst >= endSecond && startFirst < endSecond) ||
      (startFirst >= startSecond && endFirst <= endSecond)
    );
  }

  intersectsDay(first: ITimeBlockComponentItem, second: ITimeBlockComponentItem) {
    const startFirst = new Date(first.timeBlockModel.start).setHours(0, 0, 0, 0);
    const endFirst = new Date(first.timeBlockModel.end).setHours(0, 0, 0, 0);
    const startSecond = new Date(second.timeBlockModel.start).setHours(0, 0, 0, 0);
    const endSecond = new Date(second.timeBlockModel.end).setHours(0, 0, 0, 0);

    return (
      (startFirst <= startSecond && endFirst >= startSecond) ||
      (endFirst >= endSecond && startFirst <= endSecond) ||
      (startFirst >= startSecond && endFirst <= endSecond)
    );
  }
}
